import { useRoute } from "@bcm-dev/bcms-vite";
import { AddBiller } from "model";
import { SVGAsset } from "res/";
import BillerDropdownItem from "../BillerDropdownItem";

export default function BillerDropdown(props) {
    const { state, set } = props.controllers;
    const navigate = useRoute();

    const billers = AddBiller.initAll();
    const filtered = billers.filter(biller => biller.name.toLowerCase().includes(state.value.toLowerCase()));

    //const onClick = evt => navigate("/addBillerLongWorkflow/addCompany", { "state" : { "name" : state.value } });

    const onClick = evt => {
        set({ ...state, dropdown: false });

        if(props.onChange instanceof Function) {
            props.onChange(state.value)
        }
    };


    return (
        <div className="biller-search-dropdown">
            { filtered.map(item => <BillerDropdownItem key={ item.id } biller={ item } controllers={ props.controllers } onChange={ props.onChange } />) }
            <div className="row-main-content flex-container flex-horizontal align-center clickable" onClick={ onClick }>
                <div className="logo-container set-width">
                    <SVGAsset id="PlusSign" />
                </div>

                <div className="biller-info-container flex-width flex-container flex-vertical">
                    <p className="flex-item">{ state.value }</p>
                    <p className="main-text flex-item"><span data-point="biller_dropdown_add_biller">Add biller</span></p>
                </div>
            </div>

        </div>
    );
}